import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { Ability } from 'ember-can';
import type CurrentAdminService from 'garaje/services/current-admin';
import { GLOBAL_ADMIN } from 'garaje/utils/roles';
import _intersection from 'lodash/intersection';

const CAN_VISIT_AI_WATCHLIST_ROLES = [GLOBAL_ADMIN];

export default class AiWatchlistAbility extends Ability {
  @service declare currentAdmin: CurrentAdminService;

  get canVisit(): boolean {
    const { roleNames } = this.currentAdmin;
    return isPresent(_intersection(CAN_VISIT_AI_WATCHLIST_ROLES, roleNames));
  }
}
